import { createContext, SyntheticEvent, useContext } from 'react'

interface TabState {
  currentTabIndex: number
  handleTabChange: (event: SyntheticEvent | null, value: number) => void
}
interface TableState {
  currentTableIndex: number
  handleTableChange: (value: number) => void
}

export const TabContext = createContext<TabState>({
  currentTabIndex: 0,
  handleTabChange: () => {},
})
export const TableContext = createContext<TableState>({
  currentTableIndex: 0,
  handleTableChange: () => {},
})

export const useTabContext = () => useContext(TabContext)
export const useTableContext = () => useContext(TableContext)
